import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';

import classes from './IAndCLifecycleComponents.module.css';
import { pushToError } from '../../../../utils/common';
class IAndCLifecycleComponents extends Component {
  state = {
    htmlApiLoading: true
  };
  componentDidMount() {
    this.props.setCurrentRouteState('hl/components', 'I&C Lifecycle');
    if (!this.props.userfleetApiLoading) {
      $('.' + classes.IAndCLifecycleComponents).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}pc/pc.static/html/pc_componentsTable.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` }
            })
            .then(responseData => {
              $('#angularContainer').load(window.makeTextFile(responseData.data));
              this.setState({
                htmlApiLoading: false
              });
            })
            .catch(error => {
              console.error(error);
              pushToError(this.props,this.state.pname,error,url);
            });
        }
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userfleetApiLoading !== this.props.userfleetApiLoading) {
      this.setState({
        htmlApiLoading: true
      });
      $('.' + classes.IAndCLifecycleComponents).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}pc/pc.static/html/pc_componentsTable.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then(response => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false
              });
            })
            .catch(err => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading || this.props.userfleetApiLoading ? (
          <LoadingScreen />
        ) : null}
        <div className={classes.IAndCLifecycleComponents}>
          Lifecycle Components
        </div>
      </React.Fragment>
    );
  }
}

export default IAndCLifecycleComponents;
